import { z } from "zod";

/** What `POST signal/tracker/:trackerId/scan` answers (PREC-3240). */
export const RunTrackerSignalScanResultSchema = z.object({
	queued: z.number(),
	alreadyQueued: z.number(),
	credits: z.number(),
});

export type RunTrackerSignalScanResult = z.infer<typeof RunTrackerSignalScanResultSchema>;
